import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Settings from '../features/Settings'
import styles from './app.scss'
import TitleBar from '../containers/TitleBar'
import SideMenu from '../containers/SideMenu'
import MainSection from '../containers/MainSection'
import LoadingBar from '../features/LoadingBar'
import Sync from '../containers/Sync'
import ProfileSelector from '../containers/ProfileSelector'
import Rating from '../components/Rating'
import Toaster from '../features/Toaster'
import Backend from '../features/Backend'

class App extends Component {
    // Look for the steam_ticket query parameter, and if it contains
    // any text we assume it as a steam launch
    static validateIfSteam(steamTicket) {
        if (steamTicket !== undefined) return true
        return false
    }

    constructor(props) {
        super(props)

        this.state = { lastSeenNotificationId: 0 }
        this.notificationSystem = null
        this.testNotifications = false
    }

    componentDidMount() {
        // Initialize all features with the current language
        this.props.languageSet()
        this.props.javaScriptReady()

        if (this.props.isAutoLaunchEnabled()) {
            this.props.setAutoLaunchEnabledState(true)
            this.props.setAutoLaunchUrlParameter()
        } else {
            this.props.setAutoLaunchEnabledState(false)
        }
    }

    addRandomInfo() {
        const julyRelease = {
            localized: {
                en: {
                    title: 'Mass Test @ 17:00 UTC - 2017/11/23',
                    content:
                        'Join us on the Singularity test server at 17:00 UTC today for our latest Mass Test in preparation for the December release!\n\n[Find out more about Singularity and this mass test here!](https://community.eveonline.com/news/news-channels/eve-online-news/2017-11-23-next-eve-online-mass-test-new-warp-disruption-bubble-vfx-testing/)',
                },
                de: {
                    title: 'Mass Test @ 17:00 UTC - 2017/11/23',
                    content:
                        'Join us on the Singularity test server at 17:00 UTC today for our latest Mass Test in preparation for the December release!\n\n[Find out more about Singularity and this mass test here!](https://community.eveonline.com/news/news-channels/eve-online-news/2017-11-23-next-eve-online-mass-test-new-warp-disruption-bubble-vfx-testing/)',
                },
                fr: {
                    title: 'Mass Test @ 17:00 UTC - 2017/11/23',
                    content:
                        'Join us on the Singularity test server at 17:00 UTC today for our latest Mass Test in preparation for the December release!\n\n[Find out more about Singularity and this mass test here!](https://community.eveonline.com/news/news-channels/eve-online-news/2017-11-23-next-eve-online-mass-test-new-warp-disruption-bubble-vfx-testing/)',
                },
                ru: {
                    title: 'Mass Test @ 17:00 UTC - 2017/11/23',
                    content:
                        'Join us on the Singularity test server at 17:00 UTC today for our latest Mass Test in preparation for the December release!\n\n[Find out more about Singularity and this mass test here!](https://community.eveonline.com/news/news-channels/eve-online-news/2017-11-23-next-eve-online-mass-test-new-warp-disruption-bubble-vfx-testing/)',
                },
            },
            id: '5jIlJOBwBGOQSmIWw2gmgS',
            intellectualProperty: 'EVE Online',
            created: '2017-11-23T16:45:29.736Z',
            updated: '2017-11-23T16:45:29.736Z',
            version: 1,
            timeStamp: 1511455532370,
        }

        const list = []
        list[0] = julyRelease
        // list[1] = agency
        // list[2] = moonMining

        const calculatedMin = 0
        const calculatedMax = 1
        const index = Math.floor(Math.random() * (calculatedMax - calculatedMin)) + calculatedMin

        this.props.actionNotifyMotd(list[index])
    }

    render() {
        try {
            const view = this.props.showSettings ? <Settings /> : <MainSection />

            const testNotifications = this.testNotifications ? (
                <div style={{ position: 'absolute', left: '150px', top: '600px' }}>
                    <button onClick={() => this.addRandomInfo()}>Add notification</button>
                    <button onClick={() => this.props.actionNotifySuccess('Jey! :D')}>
                        Add success
                    </button>
                    <button onClick={() => this.props.actionNotifyInfo('Jey info! :D')}>
                        Add info
                    </button>
                    <button onClick={() => this.props.actionNotifyError('bingo')}>Add error</button>
                    <button
                        onClick={() =>
                            this.props.actionNotifyWarning('Jey! You better watch out...!')
                        }
                    >
                        Add warning
                    </button>
                </div>
            ) : null

            const profileSelector = this.props.showProfileSelector ? <ProfileSelector /> : null

            return (
                <div id="ccp-launcher">
                    <TitleBar />
                    <div id={styles.launcher}>
                        <SideMenu />
                        {view}
                    </div>
                    <LoadingBar />
                    {testNotifications}
                    <Sync />
                    {profileSelector}
                    <Rating />
                    <Toaster />
                    <Backend />
                </div>
            )
        } catch (error) {
            console.info(`An error occurred while rendering app: ${error.message}`)
        }
    }
}

App.propTypes = {
    showSettings: PropTypes.bool,
    showProfileSelector: PropTypes.bool,
    languageSet: PropTypes.func,
    isAutoLaunchEnabled: PropTypes.func,
    setAutoLaunchUrlParameter: PropTypes.func,
    setAutoLaunchEnabledState: PropTypes.func,
    javaScriptReady: PropTypes.func,
    actionNotifyError: PropTypes.func,
    actionNotifyWarning: PropTypes.func,
    actionNotifySuccess: PropTypes.func,
    actionNotifyInfo: PropTypes.func,
    actionNotifyMotd: PropTypes.func,
}

export default App



// WEBPACK FOOTER //
// ./src/App/app.js